import {claimFirstUseCount} from '../storage/local';

export function startUsageCount():()=>void {
  if(import.meta.env.DEV)return ()=>{};
  let disposed=false,attempted=false;
  async function attempt(){
    if(disposed||attempted||navigator.onLine===false)return;
    attempted=true;
    try {
      // Persist before sending. Retrying an unacknowledged increment could
      // double-count; without a server-side identifier we prefer undercounting.
      const first=await claimFirstUseCount();
      if(disposed)return;
      await fetch(first?'/api/first-use':'/api/return-use',{
        method:'POST',mode:'same-origin',credentials:'omit',
        referrerPolicy:'no-referrer',cache:'no-store',keepalive:true
      });
    } catch { /* Counting must never affect the app, or log request data. */ }
  }
  const online=()=>{void attempt();};
  window.addEventListener('online',online);void attempt();
  return ()=>{disposed=true;window.removeEventListener('online',online);};
}
